/**
 * Technique API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';


class TechniqueAuthor {
    
    constructor(id, firstName, lastName, email) { 
        
        TechniqueAuthor.initialize(this, id, firstName, lastName, email);
    }

    
    static initialize(obj, id, firstName, lastName, email) { 
        obj['id'] = id;
        obj['firstName'] = firstName;
        obj['lastName'] = lastName;
        obj['email'] = email;
    }

    
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new TechniqueAuthor();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('firstName')) {
                obj['firstName'] = ApiClient.convertToType(data['firstName'], 'String');
            }
            if (data.hasOwnProperty('lastName')) {
                obj['lastName'] = ApiClient.convertToType(data['lastName'], 'String');
            }
            if (data.hasOwnProperty('email')) {
                obj['email'] = ApiClient.convertToType(data['email'], 'String');
            }
        }
        return obj;
    }


}


TechniqueAuthor.prototype['id'] = undefined;


TechniqueAuthor.prototype['firstName'] = undefined;


TechniqueAuthor.prototype['lastName'] = undefined;


TechniqueAuthor.prototype['email'] = undefined;






export default TechniqueAuthor;

